var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.bookVariation)?_c('button',{staticClass:"btn flip-book-add-to-cart-btn",attrs:{"disabled":_vm.disabled,"type":"button"},on:{"click":_vm.buttonClickBook}},[_vm._v("\n  "+_vm._s(_vm.buttonText)+"\n")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }